<template>
  <div class="addr_content">
    <div class="addr_user" v-show="showText" @click="showAddress = true">
      <van-icon name="location" />
      <div class="content">
        <div>{{addressInfo.deliveryPerson}} {{addressInfo.telNo}}</div>
        <div>
          {{addressInfo.provinceName || ""}}
          {{addressInfo.cityName || ""}}
          {{addressInfo.disName || ""}}
          {{addressInfo.townName || ""}}
          {{addressInfo.detailAddr || ""}}
        </div>
      </div>
      <van-icon class="link" name="arrow" />
    </div>

    <!-- 收货地址 -->
    <van-popup v-model="showAddress" position="bottom" class="addr_pop" closeable round safe-area-inset-bottom>
      <div class="title">收货地址</div>
      <van-address-list v-model="addressID" :list="addrList" @add="onAdd" @edit="onEdit" @select="onSelectAddr" default-tag-text="默认" />
    </van-popup>

    <!-- 操作地址 -->
    <van-popup v-model="showAction" position="bottom" class="action_pop" closeable round safe-area-inset-bottom>
      <div class="title">{{actionTitle}}</div>
      <com-edit-addr ref="form" @actionComplete="actionComplete"></com-edit-addr>
    </van-popup>
  </div>
</template>

<script>
import { AddressList, Icon, Popup } from "vant";
import { GetAddrList } from "@/pages/page1/api-work/index";
import ComEditAddr from "./comEditAddr";
export default {
  components: {
    ComEditAddr,
    [AddressList.name]: AddressList,
    [Icon.name]: Icon,
    [Popup.name]: Popup,
  },
  data() {
    return {
      showText: false,
      showAddress: false,
      showAction: false,
      addrList: [],
      addressID: "",
      addressInfo: {},
      pageInfo: {
        pageNumber: 1,
        pageSize: 20,
        searchProperty: [
          {
            searchFiled: "",
            searchValue: "",
          },
        ],
        orderProperty: [],
      },
      actionTitle: "新增地址",
    };
  },
  methods: {
    openText(switchTrue) {
      this.showText = !switchTrue;
      if (switchTrue) return;
      this.getList();
    },
    getList() {
      GetAddrList({ pageInfo: this.pageInfo }).then((res) => {
        // console.log("获取地址列表", res,this.$store.state.work.addressID);
        this.addrList = res.data;
        this.addrList.forEach((v) => {
          this.$set(v, "name", v.deliveryPerson);
          this.$set(v, "tel", v.telNo);
          this.$set(
            v,
            "address",
            v.provinceName + v.cityName + v.disName + v.townName + v.detailAddr
          );
          v.isDefault = v.isDefault ? true : false;
        });
        // 新增地址 回来的时候处理逻辑
        let haveId = this.addrList.find(
          (v) => v.id === this.$store.state.work.addressID
        );
        if (haveId && this.$store.state.work.addressID) {
          this.addressInfo = haveId;
          this.addressID = haveId.id;
          return;
        }
        let defaultItem = this.addrList.find((v) => v.isDefault);
        this.addressInfo = defaultItem || this.addrList[0] || {};
        this.addressID = this.addressInfo.id;
        this.$store.commit("SET_ADDRID", this.addressID);
      });
    },
    onAdd() {
      //   console.log("新增地址");
      this.showAction = true;
      this.actionTitle = "新增地址";
      this.$nextTick(() => {
        this.$refs.form.clearForm();
      });
    },
    onEdit(item, index) {
      //   console.log("编辑地址", item, index);
      this.showAction = true;
      this.actionTitle = "编辑地址";
      this.$nextTick(() => {
        this.$refs.form.setForm(item);
      });
    },
    onSelectAddr(item, index) {
      // console.log("选中地址", item, index);
      this.showAddress = false;
      this.addressInfo = item;
      this.addressID = this.addressInfo.id;
      this.$store.commit("SET_ADDRID", this.addressID);
    },
    actionComplete() {
      this.showAction = false;
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.addr_content {
  .addr_user {
    padding: 0.2rem 0.3rem;
    background: #ffffff;
    display: flex;
    line-height: 18px;
    i {
      color: #8b8b8b;
      font-size: 18px;
      padding-top: 0.1rem;
      width: 0.6rem;
    }
    .content {
      width: calc(100% - 1.2rem);
    }
    .link {
      font-size: 24px;
      justify-self: end;
    }
  }
  .addr_pop {
    padding: 0.3rem 0;
    box-sizing: border-box;
    .title {
      text-align: center;
      color: #333333;
    }
    .van-address-list {
      height: 6.64rem;
      overflow-y: scroll;
    }
  }
  .action_pop {
    padding: 0.3rem 0;
    min-height: 80vh;
    box-sizing: border-box;
    background-color: #f7f8fa;
    .title {
      text-align: center;
      color: #333333;
    }
  }
}
</style>